import { Col, Row } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserImage from '../../../components/UserImage/UserImage';
import { LiteraryGenre } from '../../../models/literaryGenre';
import { getUserIdByPathname, getUserNameByPathname, navigateToUser } from '../../../utils/user';

import styles from './Profile.module.scss';

interface PropsProfile {
  imgSrc: string;
  name: string;
  genres: LiteraryGenre[];
  description: string;
  pagesReaded: number;
  booksReaded: number;
}

const Profile = ({description, genres, imgSrc, name, booksReaded, pagesReaded}:PropsProfile) => {
  const navigate = useNavigate()

  const userName = getUserNameByPathname();
  const UserIdByPathname = getUserIdByPathname();

  return (
    <section className={styles.container}>
      <div className={styles.containerHeader}>
        <div className={styles.readerInfo}>
          <UserImage path={imgSrc} name={name}/>
        </div>
        <div className={styles.readerInfo} onClick={() => navigate(navigateToUser(UserIdByPathname, '/bookcase'))}>
          <Row>{pagesReaded}</Row>
          <Row>páginas lidas</Row>
        </div>
        <div className={styles.readerInfo} onClick={() => navigate(navigateToUser(UserIdByPathname, '/bookcase'))}>
          <Row>{booksReaded}</Row>
          <Row>livros lidos</Row>
        </div>
      </div>
      <h1 className={styles.name}>{name}</h1>
      { !!genres.length && <h2 className={styles.genres}>Gêneros Favoritos: {genres.map(genre => genre.content).join(', ')}</h2>}
      <div className={styles.description}>
        <p>{description}</p>
      </div>
    </section>
  )
}

export default Profile;